<template>
  <v-dialog
    :value="value"
    @input="$emit('input', false)"
    width="500px"
  >
    <v-card class="pa-5 rounded-lg">
      <div class="font-weight-bold mb-5">Отложенная отправка</div>
      <DatePicker
        v-model="date"
        with-time
        :min="moment().format('YYYY-MM-DD')"
        label="Дата начала"
      />
      <div
        v-if="!dateValid"
        class="red--text mt-2"
      >
        Дата не может быть в прошлом
      </div>
      <v-row
        class="ma-0"
        justify="space-between"
      >
        <v-btn
          @click="accept()"
          class="mt-3"
          color="primary"
          :disabled="!dateValid || !date"
          :loading="loading"
        >
          <div class="text-none">Подтвердить</div>
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import DatePicker from '../../../../../components/helpers/DatePicker.vue'
  import * as moment from 'moment'
  export default {
    name: 'SendLaterModal',
    components: {
      DatePicker
    },
    props: {
      value: Boolean,
      item: Object
    },
    emits: ['accept'],
    data: () => ({
      loading: false,
      date: null,
      dateValid: true
    }),
    methods: {
      accept() {
        this.validateDate()
        if (!this.dateValid) return
        this.$emit('accept', this.date)
        this.$emit('input', false)
      },
      validateDate() {
        const date = moment.utc(this.date)
        const now = moment.utc()
        if (date.isBefore(now)) {
          this.dateValid = false
        } else {
          this.dateValid = true
        }
      }
    },
    computed: {
      moment() {
        return moment
      }
    },
    watch: {
      date() {
        this.validateDate()
      },
      value(v) {
        if (v) {
          const currentDate = this.item?.send_date
          if (currentDate) {
            this.date = currentDate
          } else {
            this.date = null
          }
        }
      }
    }
  }
</script>
